module.exports = __webpack_public_path__ + "img/info-doctor.3e10e727.svg";